export function Nome(a) {
  return {
    type: 'NAME',
    payload: {
      name: a,
    },
  };
}
